import React from "react";
import aiImage from "../../../assets/AgenticAI.jpg";
import strategyImage from "../../../assets/AgenticAI1.avif";
import strategyImage1 from "../../../assets/AgenticAI1.jpg";

export default function AgenticAI() {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="relative h-[60vh] sm:h-[70vh] md:h-[800px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={aiImage}
            alt="Agentic AI"
            className="w-full h-full object-cover sm:object-contain md:object-cover"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 sm:px-6">
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
            Agentic AI
          </h1>
          <p className="text-sm sm:text-lg md:text-xl lg:text-2xl max-w-3xl mx-auto leading-relaxed">
            Deploy autonomous AI agents that can perform complex tasks independently
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
            {/* Image - Left Side */}
            <div className="flex-1 w-full">
              <img
                src={strategyImage}
                alt="Agentic AI"
                className="w-full h-64 sm:h-80 md:h-96 object-cover rounded-lg shadow-lg"
              />
            </div>

            {/* Content - Right Side */}
            <div className="flex-1 w-full">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6 text-[#482A7A] text-center lg:text-left">
                Agentic AI
              </h2>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6 text-center lg:text-left">
                Deploy autonomous AI agents that can perform complex tasks independently. Our agentic AI solutions include intelligent automation, decision-making systems, and self-learning agents that adapt to changing environments.
              </p>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed text-center lg:text-left">
                These intelligent agents work autonomously to optimize processes, make informed decisions, and continuously improve their performance without human intervention.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* AI Agents Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-start">
            {/* Left Side - Image and LLM Content */}
            <div className="flex-1 w-full">
              <div className="text-center mb-8">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 text-[#482A7A]">
                  AI Agents
                </h2>
                <p className="text-sm sm:text-base font-semibold text-gray-800 mb-8">
                  OUTSOURCE MANUAL TASKS TO AGENTS
                </p>
              </div>
              
              <div className="mb-8">
                <img
                  src={strategyImage1}
                  alt="AI Agents"
                  className="w-full h-48 sm:h-56 object-cover rounded-lg shadow-lg mx-auto"
                />
              </div>
              
              <div className="space-y-4 text-xs sm:text-sm text-gray-600 leading-relaxed">
                <p>
                  LLM-powered agents perform complex tasks and interact intelligently with your software to automate the manual tasks currently performed by humans. These agents leverage large language models to understand context, follow instructions, and carry out a wide range of business-related activities. In the future users will be able to talk to your software and dictate tasks for agents to perform on your behalf.
                </p>
                <p>
                  Agents are used for task automation, i.e. handling repetitive tasks across various business departments, and addressing complex issues by breaking them down into manageable steps. They can communicate with customers in human-like language allowing for seamless AI-human interaction.
                </p>
              </div>
            </div>

            {/* Right Side - Key Benefits */}
            <div className="flex-1 w-full">
              <h3 className="text-xl sm:text-2xl md:text-3xl font-bold mb-8 text-[#482A7A]">
                KEY BENEFITS
              </h3>
              <div className="space-y-6">
                <div>
                  <h4 className="font-bold text-gray-800 mb-2 text-sm sm:text-base">
                    AI-POWERED USER EXPERIENCE
                  </h4>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    Create a conversational user experience with your platform or software
                  </p>
                </div>
                <div>
                  <h4 className="font-bold text-gray-800 mb-2 text-sm sm:text-base">
                    INCREASED OPERATIONAL EFFICIENCY
                  </h4>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    Handle multiple tasks simultaneously, 24/7, significantly reducing response times and increasing productivity
                  </p>
                </div>
                <div>
                  <h4 className="font-bold text-gray-800 mb-2 text-sm sm:text-base">
                    COST REDUCTION
                  </h4>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    Automate routine tasks and providing instant support, agents lower labor costs
                  </p>
                </div>
                <div>
                  <h4 className="font-bold text-gray-800 mb-2 text-sm sm:text-base">
                    DATA-DRIVEN INSIGHTS
                  </h4>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    Analyse vast amounts of data and provide valuable insights for business strategy and decision-making
                  </p>
                </div>
                <div>
                  <h4 className="font-bold text-gray-800 mb-2 text-sm sm:text-base">
                    ENHANCED CUSTOMER SUPPORT
                  </h4>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    Offer immediate, consistent, and personalized support, improving customer satisfaction and loyalty
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}